import { createMathML, MathMLRenderer } from '../../formulas/shared/MathMLRenderer';

function AboutMetricsNormalizedScore() {
  const weightDefinition = createMathML(`
    <mrow>
      <msub>
        <mi>S</mi>
        <mrow>
          <mi mathvariant="italic">norm</mi>
        </mrow>
      </msub>
      <mo>=</mo>
      <mrow>
        <mfrac>
          <mrow>
            <mi mathvariant="italic">S</mi>
            <mo>-</mo>
            <msub>
              <mi>S</mi>
              <mi>min</mi>
            </msub>
          </mrow>
          <mrow>
            <msub>
              <mi>S</mi>
              <mi>max</mi>
            </msub>
            <mo>-</mo>
            <msub>
              <mi>S</mi>
              <mi>min</mi>
            </msub>
          </mrow>
        </mfrac>
      </mrow>
    </mrow>
  `);

  return (
    <div id="normalizedScore">
      <h3>Normalized Score</h3>
      <p>
        The <strong>Normalized Score</strong> rescales the original DISGENET score to a standard 0–1 range
        while preserving relative differences between associations. This avoids compressing high-evidence
        associations that previously exceeded the original score limits and ensures comparability across the
        dataset.
      </p>
      <p>
        <strong>Formula:</strong>
        <br />
        <MathMLRenderer mathML={weightDefinition} />
        <div className="mt-3 text-sm text-gray-600">
          <dt className="font-medium">where:</dt>
          <ul className="mt-1 space-y-1">
            <li>S = original DISGENET score</li>
            <li>
              S<sub>min</sub> = minimum observed score
            </li>
            <li>
              S<sub>max</sub> = maximum observed score
            </li>
          </ul>
        </div>
      </p>
      <p>
        The lowest observed score is mapped to <strong>0</strong>, the highest to <strong>1</strong>, and all
        other scores are scaled proportionally between them.
      </p>
      <small className="italic">
        Values range from 0 to 1 and reflect the relative position of an association within the observed score
        distribution.
      </small>
    </div>
  );
}

export default AboutMetricsNormalizedScore;
